import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { checkParams } from "../../../src/util/Util";
import "./TherapistPassword.css";

const TherapistPassword = ({ setPtRegStep }) => {
  let { code } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [passVisible, setPassVisible] = useState(false);
  const [passVisibleConfirm, setPassVisibleConfirm] = useState(false);

  const [passAllValid, setPassAllValid] = useState(false);
  const [charLengthValid, setCharLengthValid] = useState(false);
  const [hasLetter, setHasLetter] = useState(false);
  const [hasNum, setHasNum] = useState(false);
  const [hasSpecChar, setHasSpecChar] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [isLoaded, setIsLoaded] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const firstPassword = useRef("");
  const secoundPassword = useRef("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorConfirmPassword, setErrorConfirmPassword] = useState("");

  useEffect(() => {
    window.onbeforeunload = null;
  }, []);

  useEffect(() => {
    setIsLoaded(false);
    axios
      .post(window.ajaxLink + "cloud_therapist/verify-invitation-code", {
        invitationCode: code,
      })
      .then((res) => {
        if (res.data.responseData) {
          setIsLoaded(true);
        }
      })
      .catch((error) => {
        console.error(error.response.data.errorData);
        setIsLoaded(true);
        if (error.response.data.responseCode === 417) {
          setShowModal(true);
          setModalMessage(error.response.data.errorData);
        }
      });
  }, [code]);

  const sweepThroughTickers = (value) => {
    setPasswordError("");
    setCharLengthValid(checkParams(value, "charLength"));
    setHasLetter(checkParams(value, "hasLetter"));
    setHasNum(checkParams(value, "hasNum"));
    setHasSpecChar(checkParams(value, "hasSpecChar"));
    setPassword(value);
    if (
      checkParams(value, "charLength") &&
      checkParams(value, "hasLetter") &&
      checkParams(value, "hasNum") &&
      checkParams(value, "hasSpecChar")
    ) {
      setPassAllValid(true);
    } else {
      setPassAllValid(false);
    }
    handleConfirmPass(value);
  };

  const handleConfirmPass = (value) => {
    if ((value || confirmPassword) !== password || secoundPassword.current.value === "") {
      setErrorConfirmPassword("Passwords don't match.");
    } else {
      setErrorConfirmPassword("");
    }
    setConfirmPassword(value);
    comparePass();
  };

  const comparePass = () => {
    if (firstPassword.current.value === secoundPassword.current.value) {
      setErrorConfirmPassword("");
    }
  };

  const checkProceed = () => {
    var proceedControl = true;
    if (!firstPassword.current.value || !passAllValid) {
      setPasswordError("Please enter a valid password.");
      proceedControl = false;
    }
    if (!secoundPassword.current.value || !passAllValid) {
      setErrorConfirmPassword("Please confirm your password.");
      proceedControl = false;
    }

    if (!passAllValid || errorConfirmPassword || password.length === 0) {
      proceedControl = false;
    }

    if (proceedControl) {
      if (JSON.parse(localStorage.getItem("new_pt_reg_data")) !== null) {
        var addPassword = JSON.parse(localStorage.getItem("new_pt_reg_data"));
        addPassword.password = password.trim();
        localStorage.setItem("new_pt_reg_data", JSON.stringify(addPassword));
        setPtRegStep(2);
      }
    }
  };

  const handleModal = () => {
    setShowModal(false);
    navigate("/login");
  };

  return (
    <div className="memberRegisterHolder web_login_holder patientLoginHolder" style={{padding: '10px'}}>
      <div className="pt_reg_title" style={{lineHeight: 1.2}}>Welcome to Virdio Health</div>
      <div className="pt_reg_subtitle" style={{lineHeight: 1.2, marginTop: '10px'}}>Complete your registration for Virdio Health by creating a password.</div>
      <>
        <div className="form_title">Password</div>
        <div className="relative_holder">
          <input
            type={passVisible ? "text" : "password"}
            className="gray_inputs gray_inputs_login inputsPatientLogin"
            onChange={(e) => sweepThroughTickers(e.currentTarget.value)}
            ref={firstPassword}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
          />
          <div className="eye_show" onClick={() => setPassVisible(!passVisible)}>
            {passVisible && <div className="crossed_eye"></div>}
          </div>
        </div>
        {password.length > 0 && (!charLengthValid || !hasLetter || !hasNum || !hasSpecChar) && (
          <>
            <div className="reg_pass_check_contain">
              <div className={"reg_pass_ticker" + (charLengthValid ? " rpass_true" : "")}></div>
              Must be at least 8 characters
            </div>
            <div className="reg_pass_check_contain">
              <div className={"reg_pass_ticker" + (hasLetter ? " rpass_true" : "")}></div>
              Minimum 1 Letter
            </div>
            <div className="reg_pass_check_contain">
              <div className={"reg_pass_ticker" + (hasNum ? " rpass_true" : "")}></div>
              Minimum 1 Number
            </div>
            <div className="reg_pass_check_contain">
              <div className={"reg_pass_ticker" + (hasSpecChar ? " rpass_true" : "")}></div>
              Minimum 1 Special character
            </div>
          </>
        )}
        {passwordError && <div className="email_error_msg">{passwordError}</div>}
        <div className="form_title">Confirm Password</div>
        <div className="relative_holder">
          <input
            type={passVisibleConfirm ? "text" : "password"}
            className="gray_inputs gray_inputs_login inputsPatientLogin"
            ref={secoundPassword}
            onChange={(e) => handleConfirmPass(e.currentTarget.value)}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
          />
          <div className="eye_show" onClick={() => setPassVisibleConfirm(!passVisibleConfirm)}>
            {passVisibleConfirm && <div className="crossed_eye"></div>}
          </div>
        </div>
        <>{errorConfirmPassword && <div className="email_error_msg">{errorConfirmPassword}</div>}</>
      </>
      <div className="pt_reg_bottom_padding">
        <div
          className={
            "signNewButton" +
            (!passAllValid || errorConfirmPassword || password.length === 0 ? " reg_procc_disabled" : "")
          }
          onClick={() => checkProceed()}
        >
          Get Started
        </div>
      </div>
      {!isLoaded && (
        <div className="full_page_loader_container">
          <div className="p_load full_page_loader_centerd"></div>
        </div>
      )}
      {showModal && (
        <div className="dlt_wrapper company-admin-modal">
          <div className="dbl_place_on_page">
            <div className="dlt_surround ">
              <div className="dlt_description">{modalMessage}</div>
              <div className="dlt_exit_btm">
                <div className="dlt_exit_btn dlt_eb_scnd dlt_lone_btn" onClick={handleModal}>
                  Go to Login
                </div>
              </div>
            </div>
          </div>
          <div className="approval_close tsk_info_cls" onClick={handleModal}></div>
        </div>
      )}
    </div>
  );
};

export default TherapistPassword;
